import { ApolloClient } from 'apollo-client'
import { InMemoryCache } from 'apollo-cache-inmemory'
// import { HttpLink } from 'apollo-link-http'
import { onError } from 'apollo-link-error'
import { IntrospectionFragmentMatcher } from 'apollo-cache-inmemory'

import { ApolloLink } from 'apollo-link'
import { setContext } from 'apollo-link-context'
import { createUploadLink } from 'apollo-upload-client'

import { apiUrl, organizationId as organizationIdFromConstants } from '~/constants'
import { Bus } from '~helper/bus'

import introspectionQueryResultData from './fragmentTypes.json'

let organizationId = organizationIdFromConstants

export const setOrganizationId = (id) => (organizationId = id)
export const getOrganizationId = () => organizationId

const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData,
})

const authLink = setContext((_, { headers, ...context }) => {
  let csfrToken = document.head.querySelector('meta[name="csrf-token"]')
  let orgId = getOrganizationId()

  return {
    headers: {
      ...headers,
      ...(orgId ? { Organization: orgId } : {}),
      'X-CSRF-TOKEN': csfrToken.content,
      accept: 'application/json',
    },
    ...context,
  }
})

/**
 * Global GraphQL Error Handler.
 *
 * Reload window if requests returns an
 * error of category authentication.
 */
const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.map(({ message, extensions }) => {
      console.log(`[GraphQL error]: Message: ${message}`)

      let outputMessage = message

      if (extensions.category === 'validation') {
        outputMessage = 'Es gab einen Fehler beim Überprüfen Ihrer Angaben.'
      }

      if (extensions.category === 'incomplete-payment') {
        Bus.$emit('notification', 'error', outputMessage)
        window.location.href = extensions.url
      }

      if (extensions.category && extensions.category === 'authentication') {
        document.location.reload()
      } else if (extensions.category !== 'payment') {
        Bus.$emit('notification', 'error', outputMessage)
      }
    })
  }

  if (networkError) {
    if (networkError.statusCode === 419) {
      document.location.reload()
    }
    console.log(`[Network error]: ${networkError}`)
  }
})

const link = ApolloLink.from([
  authLink,
  errorLink,
  new createUploadLink({ uri: apiUrl }),
])

const cache = new InMemoryCache({ fragmentMatcher })

const apolloClient = new ApolloClient({
  link,
  cache,
  credentials: 'include',
})

export default apolloClient
